import { render, staticRenderFns } from "./VFileUploaderField.vue?vue&type=template&id=3d531927&"
import script from "./VFileUploaderField.vue?vue&type=script&lang=ts&"
export * from "./VFileUploaderField.vue?vue&type=script&lang=ts&"
import style0 from "./VFileUploaderField.vue?vue&type=style&index=0&id=3d531927&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports